// src/slices/5-formsWorkSpace/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const getToken = () => {
  const tokenData = JSON.parse(sessionStorage.getItem("authUser"));
  return tokenData?.data?.token;
};

// 🟢 Training Form
export const submitTrainingForm = createAsyncThunk("forms/submitTrainingForm", async (formData, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${API_URL}/trainingForm`, formData, { headers: { Authorization: `Bearer ${getToken()}`, "Content-Type": "application/json" } });

    return response.data.data || {};
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message || "Failed to submit training form");
  }
});

// 🔵 Meeting Form
export const submitMeetingForm = createAsyncThunk("forms/submitMeetingForm", async (formData, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${API_URL}/meetingForm`, formData, { headers: { Authorization: `Bearer ${getToken()}`, "Content-Type": "application/json" } });

    return response.data.data || {};
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message || "Failed to submit meeting form");
  }
});

// 🟣 Media Agency Form
export const submitMediaAgencyForm = createAsyncThunk("forms/submitMediaAgencyForm", async (formData, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${API_URL}/mediaAgencyForm`, formData, { headers: { Authorization: `Bearer ${getToken()}`, "Content-Type": "application/json" } });

    return response.data.data || {};
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message || "Failed to submit media agency form");
  }
});

// 🟠 Consulting Form
export const submitConsultingForm = createAsyncThunk("forms/submitConsultingForm", async (formData, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${API_URL}/consultingForm`, formData, { headers: { Authorization: `Bearer ${getToken()}`, "Content-Type": "application/json" } });

    return response.data.data || {};
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message || "Failed to submit consulting form");
  }
});

// 🔶 Booking Form
export const submitBookingForm = createAsyncThunk("forms/submitBookingForm", async (formData, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${API_URL}/bookingForm`, formData, { headers: { Authorization: `Bearer ${getToken()}`, "Content-Type": "application/json" } });

    return response.data.data || {};
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message || "Failed to submit booking form");
  }
});

// Paperwork Requests
export const fetchPaperworkRequests = createAsyncThunk("forms/fetchPaperworkRequests", async (_, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${API_URL}/paperworkRequest/user`, { headers: { Authorization: `Bearer ${getToken()}` } });
    return response.data.data || [];
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message || "Failed to fetch paperwork requests");
  }
});

// --- POST Paperwork Request ---
export const submitPaperworkRequest = createAsyncThunk("forms/submitPaperworkRequest", async (formData, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${API_URL}/paperworkRequest`, formData, { headers: { Authorization: `Bearer ${getToken()}`, "Content-Type": "application/json" } });
    return response.data.data || {};
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message || "Failed to submit paperwork request");
  }
});

// 🛑 Issue Report Form
export const submitIssueReport = createAsyncThunk("forms/submitIssueReport", async (formData, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${API_URL}/issueReport`, formData, { headers: { Authorization: `Bearer ${getToken()}`, "Content-Type": "application/json" } });

    return response.data.data || {};
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message || "Failed to submit issue report");
  }
});
